import { booleanAttribute, Component, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoMessageType } from './InfoMessageType';

@Component({
    selector: 'app-info-message',
    imports: [CommonModule],
    template: `
    @if(isVisible){
    <div
      [ngClass]="[
        'alert',
        alertClass,
        sticky ? 'sticky' : '',
        withBorder ? 'bordered' : '',
        wtihBackground ? 'backGrounded' : ''
      ]"
      role="alert"
    >
      @if(!noClose){
      <button type="button" class="close" aria-label="Close" (click)="setVisible(false)">
        <i aria-hidden="true" class="bi bi-x-circle"></i>
      </button>
      } @if(title !==""){
      <h3 [class.no-margin]="!message">{{ title }}</h3>
      } @if(message !==""){
      {{ message }}
      } @if(html!==""){
      <div [innerHTML]="html"></div>
      }
    </div>
    }
  `,
    styles: `

    .alert {
      margin-bottom: 0;
      border: 1px solid transparent;
      border-radius: 0.5rem;
      padding: 0.25em;
    }

    .sticky {
      position: sticky;
      top: 0;
      z-index: 1001;
    }


    .close {
      position: absolute;
      top: 0.2rem;
      right: 0.2rem;
      padding: 0;
      background: none;
      border: none;
      font-size: 1rem;
      line-height: 1;
      color: var(--text-d);
      text-shadow: none;
      opacity: 0.5;
      cursor: pointer;
    }

    .close:hover,
    .close:focus {
      color: var(--text-d);
      text-decoration: none;
      cursor: pointer;
      opacity: 1;

    }

    .alert-info {
      color: var(--info-500);
      &.backGrounded {
        background-color: var(--info-400);
      }
      &.bordered {
        border-color: var(--info-400);
      }
    }

      .alert-warning {
        color: var(--warning-600);
          &.backGrounded {
            background-color: var(--warning-500);
          }
          &.bordered{
            border-color: var(--warning-400);
          }
      }

    .alert-danger {
      color: var(--danger-600);
        &.backGrounded {
          background-color: var(--danger-500);
        }
        &.bordered{
          border-color: var(--danger-400);
        }
    }

    .alert-success {
      color: var(--success-600);
        &.backGrounded {
          background-color: var(--success-500);
        }
        &.bordered{
          border-color: var(--success-400);
        }
    }

    .alert-neutral {
      color: var(--text-d2l);
        &.backGrounded {
          background-color: var(--background);
        }
        &.bordered{
          border-color: var(--text-d2l);
        }
    }

    .no-margin {
      margin: 0;
    }
  `
})
export class InfoMessageComponent {
  @Input() type: InfoMessageType = InfoMessageType.info;
  @Input() message: string = '';
  @Input() title: string = '';
  @Input() html: string = '';
  @Input({ transform: booleanAttribute }) withBorder = false;
  @Input({ transform: booleanAttribute }) wtihBackground = false;
  @Input({ transform: booleanAttribute }) sticky = false;
  @Input({ transform: booleanAttribute }) noClose = false;

  isVisible: boolean = true;
  ngOnInit() {
    this.isVisible = this.message !== '' || this.title !== '' || this.html !== '';
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message'] || changes['title'] || changes['html']) {
      this.isVisible = this.message !== '' || this.title !== '' || this.html !== '';
    }
  }

  get alertClass() {
    switch (this.type) {
      case 'warn':
        return 'alert-warning';
      case 'danger':
        return 'alert-danger';
      case 'success':
        return 'alert-success';
      case 'neutral':
        return 'alert-neutral';
      default:
        return 'alert-info';
    }
  }

  setVisible(b: boolean) {
    this.isVisible = b;
  }
  private setInfoMessage(
    title: string = '',
    message: string = '',
    inerHtml = '',
    type: InfoMessageType | undefined = undefined,
  ) {
    if (type !== undefined) this.type = type;
    this.setTitle(title);
    this.setMessage(message);
    this.setHtml(inerHtml);
    this.setVisible(true);
  }

  resetInfoMessage() {
    this.type = InfoMessageType.info;
    this.title = '';
    this.message = '';
    this.html = '';
    this.setVisible(false);
  }

  public updateMessage(message: string, type?: InfoMessageType) {
    this.setInfoMessage('', message, '', type);
  }
  public updateInerHtml(inerHtml: string, type?: InfoMessageType) {
    this.setInfoMessage('', '', inerHtml, type);
  }
  public setTitle(title: string = '') {
    if (!this.isNOUOE(title)) this.title = title;
  }
  public setMessage(message: string = '') {
    if (!this.isNOUOE(message)) this.message = message;
  }
  public setHtml(inerHtml: string = '') {
    if (!this.isNOUOE(inerHtml)) this.html = inerHtml;
  }
  public setType(type: InfoMessageType) {
    this.type = type;
  }
  private isNOUOE(value: unknown): boolean {
    return value === null || value === undefined || value === '';
  }
}
